<template>
	<v-dialog
		v-model="isOpen"
		width="500">
		<v-card>
			<v-form ref="form">
				<v-card-title
					class="headline"
					primary-title
				>
					{{this.title}}
				</v-card-title>
				<v-card-text>
					<h3>{{this.title + ":"}}</h3>
					<div style="cursor:pointer">
						<strong>{{mainFileName}}</strong>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on" class="ma-0 v-btn-mini" @click="downloadMainFile">
									<v-icon class="margin: 0px" small>cloud_download</v-icon>
								</v-btn>
							</template>
							<span>Pobierz dokument</span>
						</v-tooltip>
						<v-tooltip top v-if="hasProjectPanelSupervisorModificationAccess()">
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on" class="mx-0 v-btn-mini" @click="replaceMainFile">
									<v-icon class="margin: 0px" small>swap_horiz</v-icon>
								</v-btn>
							</template>
							<span>Podmień dokument</span>
						</v-tooltip>
					</div>
					<input type="file" v-show="false" ref="mainFile" id="mainFile"
						:accept="acceptedFiles"
						v-on:change="replaceFile()">
					<div v-if="attachmentList.length>0">
						<h3 class="mt-3">Załączniki:</h3>
						<div v-for="(item, index) in attachmentList" :key="index">
							<strong>{{item.fileName}}</strong>
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-btn x-small icon v-on="on" class="mx-0 v-btn-mini"
										@click="downloadAttachment(item)">
										<v-icon class="margin: 0px" small>cloud_download</v-icon>
									</v-btn>
								</template>
								<span>Pobierz dokument</span>
							</v-tooltip>
							<v-tooltip top v-if="hasProjectPanelSupervisorModificationAccess()">
								<template v-slot:activator="{ on }">
									<v-btn x-small icon v-on="on" class="mx-0 v-btn-mini"
										@click="deleteAttachment(item)">
										<v-icon class="margin: 0px" small color="red">delete</v-icon>
									</v-btn>
								</template>
								<span>Usuń załącznik</span>
							</v-tooltip>
						</div>
					</div>
					<input type="file" v-show="false" ref="addAttachment" id="addAttachment"
						:accept="acceptedFiles"
						v-on:change="uploadAttachment">
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn
						@click="$refs.addAttachment.click()">
						Dodaj załącznik
					</v-btn>
					<v-btn @click="isOpen = false">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>

	</v-dialog>

</template>

<script>
	import {Dates} from "../../../../utils/Dates";
	import {Files} from "../../../../utils/Files";
	import {Annex} from "../../../../api/generated/Annex";
	import {Api} from "../../../../api";

	export default {
		name: "ProjectAgreementDataDialog",
		mixins: [Dates, Files],

		data: function () {
			return {
				attachmentList: [],
				mainFileName: "",
				mainFile: "",
				hashToReplace: "",
				isOpen: false,
				title: "",
			};
		},

		computed: {},

		methods: {
			hasProjectPanelSupervisorModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			openDialog () {
				this.isOpen = true;
			},
			downloadMainFile () {
				this.downloadFileAsBlob(this, this.getProjectDocument(this.mainFile.id), this.mainFile.fileName);
			},
			getAttachmentList () {
				Annex.get(this, this.annexId, onSuccess => {
					if (this.dataType === "annex") {
						this.mainFileName = onSuccess.annex.fileName;
						this.mainFile = onSuccess.annex;
						this.attachmentList = onSuccess.annexAttachments;
					}
					if (this.dataType === "application") {
						this.mainFileName = onSuccess.application.fileName;
						this.mainFile = onSuccess.application;
						this.attachmentList = onSuccess.applicationAttachments;
					}
				});
			},

			replaceMainFile () {
				this.$refs.mainFile.click();
			},

			deleteAttachment (item) {
				Annex.deleteAttachment(this, this.$route.params.projectId, this.annexId, item.id, this.dataType,
					successResponse => {
						this.$messagesBus.$emit("success", "Załącznik został usunięty", successResponse);
						this.getAttachmentList();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie usunąć załącznika", errorResponse);

					});
			},

			getReplaceMainFileUrl () {
				return "/annex/update-annex-file";
			},

			async replaceFile () {
				if (!this.$refs.mainFile.files[0]) {
					return;
				}
				if (this.hasIncorrectFilesExtension(this.$refs.mainFile.files)) {
					Files.methods.clearFileInput('mainFile');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.mainFile.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput("mainFile");
					return;
				}
				let url = this.getReplaceMainFileUrl();

				Api.postMultipart(this, url,
					this.$refs.mainFile.files[0],
					{
						"projectId": this.$route.params.projectId,
						"annexId": this.annexId,
						"isApplication": this.dataType === "application",
					},
					successResponse => {
						this.$messagesBus.$emit("success", "Dokument został podmieniony", successResponse);
            Files.methods.clearFileInput("mainFile");
						this.$emit("refresh");
						this.getAttachmentList();

					},
					errorResponse => {
            Files.methods.clearFileInput("mainFile");
						this.$messagesBus.$emit("error", "Nie udało się poprawnie podmienić dokumentu", errorResponse);
					});
			},

			async uploadAttachment () {
				if (this.hasIncorrectFilesExtension(this.$refs.addAttachment.files)) {
					Files.methods.clearFileInput('addAttachment');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.addAttachment.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput("addAttachment");
					return;
				}
				Api.postMultipart(this, "/annex/".concat(this.dataType).concat("-attachment"),
					this.$refs.addAttachment.files[0],
					{
						"projectId": this.$route.params.projectId,
						"annexId": this.annexId,
					},
					successResponse => {
						this.$messagesBus.$emit("success", "Dokument został dodany", successResponse);
            Files.methods.clearFileInput("addAttachment");
						this.getAttachmentList();
					},
					errorResponse => {
            Files.methods.clearFileInput("addAttachment");
						this.$messagesBus.$emit("error", "Nie udało się poprawnie dodać dokumentu", errorResponse);
					});
			},
			downloadAttachment (item) {
				this.downloadFileAsBlob(this, this.getProjectDocument(item.id), item.fileName);
			},
		},


		props: {
			annexId: {
				type: Number,
			},
			dataType: {
				type: String,
			},
		},

		watch: {
			isOpen: function (val) {
				if (val === true) {
					this.getAttachmentList();
				}
				if (this.dataType === "annex") {
					this.title = "Aneks";
				}
				if (this.dataType === "application") {
					this.title = "Wniosek";
				}

			},
		},

	};
</script>

<style scoped>

</style>
